import axios from "axios";

export class HawkingsService {
    async getChats(roomId: number, page: number) {
        return await axios.get(`api/hawkings/rooms/${roomId}/chats?page=${page}&itemsPerPage=30`);
    }
    async getChatHistory(idChat: number, roomId, page: number) {
        return await axios.get(`api/hawkings/rooms/${roomId}/chats/${idChat}/history?page=${page}&itemsPerPage=30`);
    }
    async sendExamGenerator(id: number) {
        const headers = {
            'Content-Type': "application/json",
            'Authorization':
                "Bearer " + localStorage.getItem('token'),
        };
        return await fetch(process.env.VUE_APP_API_BASE + `api/hawkings/exams/${id}/generate`, { method: "POST", body: JSON.stringify({}), headers: headers });
    }
    async createExam(data: any) {
        return await axios.post(`api/hawkings/exams`, data);
    }
    async downloadExam(id: number) {
        return await axios.get(`api/hawkings/exams/${id}/download_word`, { responseType: 'blob' });
    }
    async sendMessageChat(data: any, id: number) {
        return await axios.post(`api/hawkings/chats/${id}/send_message`, data, { responseType: 'stream' });
    }
    async fetchSendMessageChat(data: any, id: number, roomId: number) {
        const headers = {
            'Content-Type': "application/json",
            'Authorization':
                "Bearer " + localStorage.getItem('token'),
        };
        return await fetch(process.env.VUE_APP_API_BASE + `api/hawkings/rooms/${roomId}/chats/${id}/send_message`, { method: "POST", body: JSON.stringify(data), headers: headers });
    }
    async fetchSendMessageChatGPT(data: any, id: number) {
        const headers = {
            'Content-Type': "application/json",
            'Authorization':
                "Bearer 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",
        };
        return await fetch("https://api.openai.com/v1/chat/completions", { method: "POST", body: JSON.stringify(data), headers: headers });
    }
    async createChat(roomId: number) {
        return await axios.post(`api/hawkings/rooms/${roomId}/chats`, {});
    }
    async createTitleChat(id: number, roomId: number) {
        return await axios.put(`api/hawkings/rooms/${roomId}/chats/${id}/create_title`, {});
    }
    async register(data): Promise<any> {
        return await axios.post(`/api/hawkings/single_player/register`, data);
    }
    async activateRegistrationUser(token: string): Promise<any> {
        return await axios.post(`api/hawkings/single_player/activate_user/${token}`, {});
    }
    async myBundle(): Promise<any> {
        return await axios.get(`/api/hawkings/my_bundle`);
    }
    async getBotChats(botId: number, page: number) {
        return await axios.get(`api/hawkings/bots/${botId}/chats?page=${page}&itemsPerPage=30`);
    }
    async createBotChat(botId: number) {
        return await axios.post(`api/hawkings/bots/${botId}/chats`, {});
    }
    async fetchSendBotMessageChat(data: any, id: number) {
        const headers = {
            'Content-Type': "application/json",
            'Authorization':
                "Bearer " + localStorage.getItem('token'),
        };
        return await fetch(process.env.VUE_APP_API_BASE + `api/hawkings/chats/${id}/send_message`, { method: "POST", body: JSON.stringify(data), headers: headers });
    }
    async createBotTitleChat(id: number) {
        return await axios.put(`api/hawkings/chats/${id}/create_title`, {});
    }
    async getBotChatHistory(idChat: number, page: number) {
        return await axios.get(`api/hawkings/chats/${idChat}/history?page=${page}&itemsPerPage=30`);
    }
    async getQuestions(idChat: number, roomId: number) {
        return await axios.get(`api/hawkings/rooms/${roomId}/chats/${idChat}/get_questions`);
    }
    async getSingleQuestions(idChat: number) {
        return await axios.get(`api/hawkings/chats/${idChat}/get_questions`);
    }
}